import Config from "../../config";
import { Heading } from "@aws-amplify/ui-react";
import React from "react";

const Logo = () => {
  return <Heading fontSize="25px" color="#dac57a" backgroundColor="#173660" width="fit-content" margin="10px auto" marginTop="8px" padding="1px 5px" borderRadius="5px">{Config.headerText}</Heading>;
};

export default Logo;
